<template>
  <table
    v-if="data"
    class="data-table"
  >
    <tr>
      <th
        v-for="(item, i) in headers"
        :key="`header-${i}`"
      >
        <span class="nowrap">{{ item }}</span>
      </th>
    </tr>
    <tr
      v-for="(row, i) in data"
      :key="`row-${i}`"
    >
      <td
        v-for="(item, j) in row"
        :key="`row-${i}-item-${j}`"
        :class="getClassName(item)"
      >
        <template v-if="item.type === 'chart'">
          <chart-wrapper />
        </template>
        <template v-else>
          {{ item.text || 'n/a' }}
        </template>
      </td>
    </tr>
  </table>
</template>

<script>
import ChartWrapper from '@/components/tiny/ChartWrapper';
import Intersect from 'vue-intersect';

export default {
  name: 'data-table',
  components: {
    ChartWrapper,
    Intersect,
  },
  props: {
    headers: {
      type: Array,
      default: null,
    },
    rows: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      data: null,
    };
  },
  created() {
    this.data = this.rows.map(row => row.map(col => {
      const newCol = { ...col };
      if (col.type === 'chart') {
        newCol.isInView = false;
      }
      return newCol;
    }));
  },
  methods: {
    getClassName(item) {
      const className = [];
      if (item.className) {
        className.push(item.className);
      }

      if (item.img) {
        className.push('image');
      }
      return className;
    },
  },
};
</script>

<style scoped lang="scss">
.data-table {
  width: 100%;
  font-size: 12px;
  color: #6e7c91;
  tr {
    background-color: #fff;
    &:nth-child(even) {
      background-color: #f7f9fc;
    }
  }
  th, td {
    border: none;
    padding: 9px 14px;
    vertical-align: middle;
  }
  th {
    text-align: left;
    font-weight: 700;
  }
  td {
    &.price {
      color: #6972de;
      text-decoration: underline;
      font-weight: 700;
    }
    &.image {
      img {
        display: block;
        max-width: 135px;
        height: auto;
      }
    }
  }
  .chart {
    width: 132px;
    height: 30px;
  }
}
.nowrap {
  display: block;
  white-space: nowrap;
}
</style>
